import { useQuery } from '@tanstack/react-query';
import { EmployeeTimeOffAvailabilityResponse } from '../../../types/EmployeeTimeOff';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

export type EmployeeTimeOffAvailabilityParams = {
  employee_uuids: string[];
  start_date: string;
  end_date: string;
};

export const fetchEmployeeTimeOffAvailability = async (params: EmployeeTimeOffAvailabilityParams) => {
  const response = await CustomAxios.get<EmployeeTimeOffAvailabilityResponse>('employee_time_offs/availability', { params });
  return response.data;
};

type UseGetEmployeeTimeOffAvailabilityProps = {
  params: EmployeeTimeOffAvailabilityParams;
  enabled?: boolean;
};

export function useGetEmployeeTimeOffAvailability({ params, enabled = true }: UseGetEmployeeTimeOffAvailabilityProps) {
  return useQuery({
    enabled,
    queryKey: [queryKeys.employeeTimeOffAvailability, params],
    queryFn: () => fetchEmployeeTimeOffAvailability(params),
  });
}
